<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4 d-flex justify-content-between">
				<div class="d-flex">
					<h1 class="h3 mb-0 text-gray-800">
						Usuários
					</h1>
				</div>
				<div>
					<button 
						class="btn btn-primary ml-2"
						@click="create()">
						Novo
					</button>
				</div>
			</div>
			<div class="card">
                <div class="card-header">
		        	<div class="d-flex justify-content-between container-fluid">
			            <div class="text-muted fs-19">
			            	<strong>Registros</strong>
			            </div>
				    </div>
		        </div>
		        <div class="card-body">
		            <user-table 
		            	:key="user_key"
		            	@update="update"
		            	@destroy="destroy"
		            ></user-table>
		        </div>
		    </div>
		</div>
		<user-create 
			@reload="reload">
		</user-create>
		<user-update 
			:dado_id="dado_id" 
			@reload="reload">
		</user-update>
		<!-- Delete -->
		<bsh-confirm 
        	modal_id="confirm_destroy_user" 
        	:dado_id="dado_id" 
        	title="Deseja realmente desativar este usuário?" 
        	btn="Desativar" 
        	btnStyle="btn-danger" 
        	method="delete" 
        	:rota="$url+'/api/adm/users/destroy/'" 
        	@reload="reload">
        </bsh-confirm>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dado_id: 0,
				user_key: 0
			}
		},
		methods: {
			create(){
				$('#create_user').modal('show');
			},
			update(dado_id){
				this.dado_id = dado_id;
				$('#update_user').modal('show');
			},
			destroy(dado_id){
				this.dado_id = dado_id;
				$('#confirm_destroy_user').modal('show');
			},
			reload(){
				this.user_key += 1;
			}
		}
	}
</script>